import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { NgbdModalComponent } from 'src/app/modal/modal';
import { AddPmsUserComponent } from '../dialogs/add-pms-user/add-pms-user.component';
import { MappingManagementComponent } from '../dialogs/mapping-management/mapping-management.component';
import { PMSPartner, PMSPartnerUser } from '../models/pmspartner';
import { PmsManagementService } from '../services/pms-management.service';

@Component({
  selector: 'app-pms-management',
  templateUrl: './pms-management.component.html',
  styleUrls: ['./pms-management.component.less']
})
export class PmsManagementComponent implements OnInit {

  users: PMSPartnerUser[] = [];
  partnersLoaded: boolean = false;

  constructor(public pmsService: PmsManagementService, private modalService: NgbModal, private toast: ToastrService) { }

  ngOnInit() {
    this._loadPartnerUsers();
  }

  private _loadPartnerUsers(): void {
    this.pmsService.GetPMSPartnerUsers().subscribe((res: PMSPartnerUser[]) => {
      console.log(res);
      if(res) {
        this.users = res;
        this.pmsService.GetPMSPartners().subscribe((res: PMSPartner[]) => {
          if(res) {
            this.pmsService.pmsPartners = res;
            _.forEach(this.users, u => {
              let partner = res.find(rec => { return rec.id === u.pmsPartnerId });
              if(partner) u.pmsPartnerName = partner.partnerName;
            })

            this.partnersLoaded = true;
          }
        })
      }
    },
    err => { this.toast.error('Error fetching PMS Partner Users', '', { closeButton: true, disableTimeOut: true }) },
    () => {});
  }

  disableUser(u: PMSPartnerUser): void {
    this.pmsService.DisablePMSUser(u).subscribe(res => {
      u.isLocked = true;
    },
    err => { this.toast.error('Error disabling user', '', { disableTimeOut: true, closeButton: true }) },
    () => {} )
  }

  manageMappings(u: PMSPartnerUser): void {
    const dialog = this.modalService.open(MappingManagementComponent, { centered: true, size: 'xl' });
    dialog.componentInstance.name = 'Manage Mapping';
    dialog.componentInstance.partnerUser = u;
  }

  addNewUser(): void {
    const modal = this.modalService.open(AddPmsUserComponent, { centered: true, size: 'lg' });
    modal.componentInstance.name = 'New User Modal';
    modal.componentInstance.onSavedEvent.subscribe(p => {
      if(p) this._loadPartnerUsers();
    })
  }

}
